import { useEffect, useRef, useState } from "react";
import {
  matchPath,
  Outlet,
  useLocation,
  useSearchParams,
} from "react-router-dom";
import classnames from "classnames";
import { getSettings } from "./Header.config.js";
import Header from "./Header.jsx";
import phoneOverlay from "../assets/images/BlackPhoneEdge.png";
import { useLanguage } from "./LanguageContext.jsx";

function PageLayout() {
  const location = useLocation();
  const [params] = useSearchParams();
  const isKiosk = params.get("kiosk");
  const { strings } = useLanguage();
  const headerConfig = getSettings(strings).find((config) =>
    matchPath(location.pathname, config.route)
  );
  const isMenuPage = [/\/$/, /\/chatbot\/chat\/?$/].some((slugRe) =>
    slugRe.test(location.pathname)
  );

  const [headerHasRendered, setHeaderHasRendered] = useState(false);
  const [bodyHasRendered, setBodyHasRendered] = useState(false);
  const headerRef = useRef();
  const bodyRef = useRef();

  useEffect(() => {
    if (headerHasRendered && bodyHasRendered) {
      bodyRef.current.style.height = `calc(100% - ${
        getComputedStyle(headerRef.current).height
      }`;

      if (isKiosk) {
        parseFrame().then(({ frameThicknessWidth }) => {
          bodyRef.current.style.marginRight = `${frameThicknessWidth}px`;
          bodyRef.current.style.marginLeft = `${frameThicknessWidth}px`;
          headerRef.current.style.marginLeft = `${frameThicknessWidth}px`;
          headerRef.current.style.marginRight = `${frameThicknessWidth}px`;
        });
      }
    }
  }, [headerHasRendered, bodyHasRendered, location, isKiosk]);

  function parseFrame() {
    return new Promise((resolve) => {
      const img = new Image(window.innerWidth, window.innerHeight);
      img.src = phoneOverlay;
      img.addEventListener("load", () => {
        // get the pixel data for the frame PNG
        const canvas = document.createElement("canvas");
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, window.innerWidth, window.innerHeight);

        const imgData = ctx.getImageData(
          0,
          0,
          window.innerWidth,
          window.innerHeight
        );

        // each px = (r, g, b, a)
        // the first idx of the row = row # * px width * 4
        const rowStartIdx = Math.round(imgData.height / 2) * imgData.width * 4;

        let w = 0;
        for (let i = 3; i < imgData.width; i += 4) {
          w += 1;
          if (imgData.data[rowStartIdx + i] !== 255) {
            break;
          }
        }
        resolve({ frameThicknessWidth: w - 3 });
      });
    });
  }

  return (
    <div className="app">
      {isKiosk ? (
        <img src={phoneOverlay} alt="" className="app__phone-overlay" />
      ) : null}
      <Header
        color={headerConfig.color}
        nav={headerConfig.nav}
        route={headerConfig.route}
        ref={(n) => {
          if (n) {
            setHeaderHasRendered(true);
            headerRef.current = n;
          } else {
            setHeaderHasRendered(false);
            headerRef.current = null;
          }
        }}
      >
        {headerConfig.text}
      </Header>
      <article
        className={classnames("main-content", {
          "main-content--topics": isMenuPage,
          "main-content--chat": !isMenuPage,
          "main-content--kiosk": isKiosk,
        })}
        ref={(n) => {
          if (n) {
            setBodyHasRendered(true);
            bodyRef.current = n;
          } else {
            setBodyHasRendered(false);
            bodyRef.current = null;
          }
        }}
      >
        <Outlet />
      </article>
    </div>
  );
}

export default PageLayout;
